import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import { registerReducer } from './screens/Register/reducers';
import { citiesReducer } from './redux/cities/reducer';
import { applicationReducer } from './redux/application/reducer';
import { subscriptionsReducer } from './redux/subscriptions/reducer';
import { paymentReducer } from './redux/payment/reducer';

export default {
    routing: routerReducer,
    form: formReducer,
    register: registerReducer,
    cities: citiesReducer,
    application: applicationReducer,
    subscriptions: subscriptionsReducer,
    payment: paymentReducer,
};
